<template>
  <div>
	<promoter v-if="nodeConfig.type==0" :model-value="nodeConfig"></promoter>

	<approver v-if="nodeConfig.type==1" :model-value="nodeConfig"></approver>

	<send v-if="nodeConfig.type==2" :model-value="nodeConfig"></send>

	<branch v-if="nodeConfig.type==4" :model-value="nodeConfig">
		<template v-slot="slot">
			<node-wrap v-if="slot.node" :model-value="slot.node.childNode"></node-wrap>
		</template>
	</branch>

	<node-wrap v-if="nodeConfig.childNode" :model-value="nodeConfig.childNode"></node-wrap>
  </div>
</template>

<script>
	import approver from './nodes/approver.vue'
	import promoter from './nodes/promoter.vue'
	import branch from './nodes/branch.vue'
	import send from './nodes/send.vue'

	export default {
		props: {
			modelValue: { type: Object, default: () => {} }
		},
		components: {
			approver,
			promoter,
			branch,
			send
		},
		data() {
			return {
				nodeConfig: {},
			}
		},
		watch:{
			modelValue(val){
        console.log(val)
				this.nodeConfig = val
			},
			nodeConfig(val){
				this.$emit("update:modelValue", val)
			}
		},
		mounted() {
			this.nodeConfig = this.modelValue
		},
		methods: {

		}
	}
</script>

<style>
</style>
